import { render, staticRenderFns } from "./Forget.vue?vue&type=template&id=6650355e&scoped=true&"
import script from "./Forget.vue?vue&type=script&lang=ts&"
export * from "./Forget.vue?vue&type=script&lang=ts&"
import style0 from "./Forget.vue?vue&type=style&index=0&id=6650355e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6650355e",
  null
  
)

export default component.exports